import { LangObject } from "@brg/api/dist/api-core/utils/lang-utils";
import { FC, useState, useEffect, useMemo, ReactElement } from "react";
import { ITeamFilterModel } from "../types";
import { GlobalColoring } from "shared/pages/projectEdit/styles";
import { Tag } from "@brg/api";
import { useTranslation } from "react-i18next";
import { useBreakpoint } from "@brg/ui";
import { ComputedTeam } from 'shared/helpers/types/computed/ComputedTeam';
import { useDispatch, useSelector } from "react-redux";
import { setType } from "../../../reducers/ViewTypeSlice";
import { ICoverContent } from "shared/pages/exploreHseContextsNew/const/coverContent";
import { CustomBgWrapper } from "shared/components/CustomBgWrapper/CustomBgWrapper";
import { createPortal } from "react-dom";
import styled, { ThemeProvider, useTheme, css } from "styled-components";
import { PSpresentationBlock } from "shared/pages/project/sections/ps-presentation-block";
import { PageViewportLayout } from "shared/components/template";
import { EmptyLink, LimitedLink, Title, sortTags } from "shared/pages/project/project";
import { AGEYTOMESH_TAG_ID } from "shared/constants/misc";
import { BTag } from "core/components";
import { bTag, LayoutConst } from 'core';
import { CreateLinkTo } from "shared/constants/linkTo";
import { PSLongread } from "shared/pages/project/sections/ps-longread";
import { TeamTempButtons } from "./TeamTempButtons";
import { createThemeByColor } from "shared/helpers/coloring";
import { useScrollByAnchorElement } from "shared/hooks/useScrollByAnchorElement";
import { useInstantScroll } from "shared/hooks/useSmoothScroll";
import { ANCHOR_TYPE, IAddProjectCoverContent } from "shared/pages/projectEdit/components/PresentatitonBlock/types/AdditionalContentType";
import { HseContextSelector } from "shared/reducers/hseCurrentContext";
import { ProjectAnchorNavigate as Navigation } from "shared/pages/project/components/ProjectAnchorNavigate";


export interface ITeamTab {
    path: string;
    name: LangObject[];
    about: LangObject[];
    filter: ITeamFilterModel;
    isMain: boolean;
}

type TeamTabEditPropsT = {
    title?: any;
    titleVisible?: boolean;
    additionalContent?: IAddProjectCoverContent;
    managedTags: Tag[];
    teamTags: Tag[];
    team: ComputedTeam;
    isModer?: boolean;
    buttons?: ReactElement;
    color: string;
    isPreview?: boolean;
    mobileEditorAction?: string;
    onUpdate?: () => void;
    projectSource?: any;
}

const ButtonsWrapper = styled.div<{ isBlackTheme?: boolean }>`
  position: relative;
  ${({ isBlackTheme }) => {
    // console.log(isBlackTheme)
    return isBlackTheme ? css`
    .hollow-button, .filled-button {
      color: #fefefe;
    }
  ` : null}};
`;

export const TeamLgView: FC<TeamTabEditPropsT> = (props) => {
    const { i18n } = useTranslation();
    const dispatch = useDispatch();
    const theme = useTheme();
    const is743 = useBreakpoint(LayoutConst.screen.s - 1);
    const outer = document.getElementById('landing-nav-portal');
    useScrollByAnchorElement();
    const { anchorLinks } = useSelector(HseContextSelector);
    
    const { scrollToElement } = useInstantScroll({
        navbarHeight: 64,
        anchorMenuHeight: 50,
        extraOffset: -40,
        minDuration: 2000,
        maxDuration: 2000,
        scrollSpeed: 1.0
    });

    // ВРЕМЕННОЕ РЕШЕНИЕ: Обработчик hash для TeamLgView
    // TODO: Рефакторить систему загрузки контента для интеграции с React
    // Проблема: динамический контент загружается после монтирования компонентов
    // Решение: повторные попытки поиска элемента с прокруткой страницы для загрузки контента
    useEffect(() => {
        const handleHashOnLoad = () => {
            if (window.location.hash) {
                const hash = window.location.hash.replace('#', '');
                
                const findAndScrollToElement = (targetId: string, attempts = 0, maxAttempts = 30) => {
                    let element = document.querySelector(`[data-rbd-draggable-id="${targetId}"]`);
                    if (!element) {
                        element = document.getElementById(targetId);
                    }
                    if (!element) {
                        element = document.querySelector(`[data-post-id="${targetId}"]`);
                    }
                    if (!element) {
                        element = document.querySelector(`[data-anchor="${targetId}"]`);
                    }
                    
                    if (element) {
                        scrollToElement(targetId, false);
                        return;
                    }
                    
                    if (attempts < maxAttempts) {
                        if (attempts % 5 === 0) {
                            window.scrollTo({
                                top: document.body.scrollHeight,
                                behavior: 'smooth'
                            });
                        }
                        
                        setTimeout(() => {
                            findAndScrollToElement(targetId, attempts + 1, maxAttempts);
                        }, 200);
                    }
                };
                
                setTimeout(() => {
                    findAndScrollToElement(hash);
                }, 1000);
            }
        };
        
        handleHashOnLoad();
        
        window.addEventListener('load', handleHashOnLoad);
        
        window.addEventListener('hashchange', handleHashOnLoad);
        
        return () => {
            window.removeEventListener('load', handleHashOnLoad);
            window.removeEventListener('hashchange', handleHashOnLoad);
        };
    }, [scrollToElement]);

    const { team, color, additionalContent, managedTags, teamTags, buttons, title, titleVisible, onUpdate, projectSource  } = props;

    const [longreadReady, setLongreadReady] = useState<boolean | null>(null);
    const [lgLength, setLgLength] = useState(0);

    const onLongreadIsReady = (val: any) => {
        setLongreadReady(val || true)
    }

    const { longread } = team;

    const vtype = !!longread ? longread?.viewType : 't-shape';

    const newTheme = useMemo(() => {
      const { theme: newTheme } = createThemeByColor(color, theme);
      return newTheme
    }, [color, theme])
     //@ts-ignore
    const isTeamHasLongreadCover = !!team?.longreadType 
         
    const customAdditionalContent = useMemo(() => 
          //@ts-ignore
          isTeamHasLongreadCover ? projectSource?.additionalContent : team?.additionalContent,
          [isTeamHasLongreadCover, projectSource, team]
        );
        
    const getAdjustedColor = (defaultColor: string, contentColor: string | undefined): string | undefined => 
          defaultColor === "#FEFEFE" && contentColor === "#FEFEFE" ? '#000000' : contentColor;
        
    const titleColor = getAdjustedColor(color, customAdditionalContent?.title?.color);
    const subtitleColor = getAdjustedColor(color, customAdditionalContent?.subtitle?.color);
    const projectBg = useMemo(() => (team?.additionalInfo?.color || '#fff') , [team])
    

  useEffect(() => {
    const element = document.querySelector('.first_as_cover-container') as HTMLElement
    if (element) {
      const navbar = document.querySelector('#navbar') as HTMLElement;
      const footer = document.querySelector("#footer-portal > div") as HTMLElement;
      const navbarHeight = navbar?.offsetHeight;
      const footerHeight = footer?.offsetHeight;
      const elementHeight = element.offsetHeight;
      const windowHeight = window.innerHeight;
      const diff = elementHeight + navbarHeight - windowHeight;
      if (diff > 0) {
        setTimeout(() => {
          window.scrollTo({top: diff + footerHeight, behavior: 'smooth'});
        }, 0)
      }
    }
  }, [longreadReady])

    const navgationVisible = useMemo(() => {
        if (customAdditionalContent) {
            const content = customAdditionalContent as IAddProjectCoverContent
            return !!content?.anchors?.anchorVisible && content?.anchors?.anchorType === ANCHOR_TYPE.popup && anchorLinks?.length
        }
        return undefined
    }, [customAdditionalContent, anchorLinks])

    const navigation = useMemo(() => {
      if (outer && navgationVisible) {
        return (
            createPortal(
                <Navigation 
                  anchors={anchorLinks} 
                  bg={projectBg}
                  element={document.body}
                />
            , document.body)
        )
      }
    } , [anchorLinks, projectBg, navgationVisible, outer, longreadReady])

    const PresentationBlock = useMemo(() => {
      const isBlack = newTheme?.app?.backgroundColor === '#2A3034';

      return (
          <ThemeProvider theme={newTheme}>
            <PSpresentationBlock
          //@ts-ignore 
              project={team}
              anchors={anchorLinks}
              title={ 
                  titleVisible ? (
                      <Title isAgeytomesh={false} isProjectEdit={false}>
                          {/*@ts-ignore*/}
                          {title?.text}
                      </Title>
                  ) : undefined
              }
              titleColor={titleColor}
              subtitleColor={subtitleColor}
              tags={sortTags([...teamTags, ...managedTags]).map((v) => {
                  const target = (v.tagId === AGEYTOMESH_TAG_ID || v.isTeamTag) ? '_blank' : '';
                
                  if (v.tagId === AGEYTOMESH_TAG_ID) {
                    return (
                      <EmptyLink key={v.tagId} onClick={() => window.open(process.env.REACT_APP_URL_AGEYTOMESH, target)}>
                      {/*@ts-ignore*/}
                      <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag>
                        {bTag.title(v)}
                      </BTag>
                      </EmptyLink>
                    )
                  }
                  return (
                    <LimitedLink key={v.tagId} to={CreateLinkTo.tag(v.tagId)} target={target}>
                      {/*@ts-ignore*/}
                      <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} /*organization={isRequired(v, organizationEntity.tagIds, true)}*/ isProjectsTag>
                        {bTag.title(v)}
                      </BTag>
                    </LimitedLink>
                  )
                  })
                }
                bottom={<TeamTempButtons team={team} />}
                //@ts-ignore
              //bottom={<ProjectButtons dropdownVerticalPos={isEmptyProjectTags ? 'top' : "bottom"} orientation={'horizontal'} project={team} onShouldReload={undefined}/>}
                //@ts-ignore
              //   dialog={ team && <OrganizationApprovalDialog project={team}/>}
          />
            <ButtonsWrapper isBlackTheme={isBlack}>
              {!is743 && (
                <>
                  <div id={'landing-nav-portal'} style={{ position: 'relative' }} />
                  {buttons}
                </>
              )}
          </ButtonsWrapper>
          {is743 && buttons}
      </ThemeProvider>
      )
    }, [buttons, anchorLinks, team, projectBg, title, titleVisible, i18n.language, titleColor, subtitleColor, newTheme, projectSource])

    //@ts-ignore
    const coverContent: ICoverContent = useMemo(() => {
        return {
          firstAsCover: true,
          editorComponent:  PresentationBlock,
          setFirstCover: undefined,
          isPresentation: true,
          onLongreadIsReady: onLongreadIsReady,
        }
      }, [i18n.language, titleColor, subtitleColor, anchorLinks])

    const lgPortalRef = useMemo(() => (longreadReady && document.querySelector("#lg-presentation-portal")), [longreadReady])

    useEffect(() => {
        dispatch(setType(vtype));
    }, [dispatch, vtype])

    useEffect(() => onUpdate && onUpdate() , [i18n.language, anchorLinks])

    const handleSetLgLength = (val: number) => {
        setLgLength(val)
    } 

    return (   
      <ThemeProvider theme={newTheme}>
        <PageViewportLayout vtype={vtype} offsetTop={0}>
            {/*<ProjectEditPageGrid isTeamPage offsetBottom={40}>*/}
            <CustomBgWrapper backgroundColor={color}>
            <GlobalColoring color={color} /*brighter={color.brighter} darker={color.darker}*/ />
            {/* {navigation} */}
            <PSLongread 
            //@ts-ignore
                project={team}
                longReadLength={lgLength}
                additionalContent={additionalContent}
                setLongReadLength={handleSetLgLength}
                mobileEditorAction={props.mobileEditorAction}
                // toggleMobileEditor={onToggleMobileEditor}
                // onSetMobTextLength={onSetMobTextBlockLength}
                isTeamLG
                coverContent={{...coverContent}}
                //@ts-ignore
                customLGId={team?.longreadType && team?.replaceLongreadId}
                projectSource={projectSource}
            />
            </CustomBgWrapper>
        {/*</ProjectEditPageGrid>*/}
        </PageViewportLayout>
      </ThemeProvider>
    );
};
import { LangObject } from "@brg/api/dist/api-core/utils/lang-utils";
import { FC, useState, useEffect, useMemo, ReactElement } from "react";
import { ITeamFilterModel } from "../types";
import { GlobalColoring } from "shared/pages/projectEdit/styles";
import { Tag } from "@brg/api";
import { useTranslation } from "react-i18next";
import { useBreakpoint } from "@brg/ui";
import { ComputedTeam } from 'shared/helpers/types/computed/ComputedTeam';
import { useDispatch, useSelector } from "react-redux";
import { setType } from "../../../reducers/ViewTypeSlice";
import { ICoverContent } from "shared/pages/exploreHseContextsNew/const/coverContent";
import { CustomBgWrapper } from "shared/components/CustomBgWrapper/CustomBgWrapper";
import { createPortal } from "react-dom";
import styled, { ThemeProvider, useTheme, css } from "styled-components";
import { PSpresentationBlock } from "shared/pages/project/sections/ps-presentation-block";
import { PageViewportLayout } from "shared/components/template";
import { EmptyLink, LimitedLink, Title, sortTags } from "shared/pages/project/project";
import { AGEYTOMESH_TAG_ID } from "shared/constants/misc";
import { BTag } from "core/components";
import { bTag, LayoutConst } from 'core';
import { CreateLinkTo } from "shared/constants/linkTo";
import { PSLongread } from "shared/pages/project/sections/ps-longread";
import { TeamTempButtons } from "./TeamTempButtons";
import { createThemeByColor } from "shared/helpers/coloring";
import { useScrollByAnchorElement } from "shared/hooks/useScrollByAnchorElement";
import { useInstantScroll } from "shared/hooks/useSmoothScroll";
import { ANCHOR_TYPE, IAddProjectCoverContent } from "shared/pages/projectEdit/components/PresentatitonBlock/types/AdditionalContentType";
import { HseContextSelector } from "shared/reducers/hseCurrentContext";
import { ProjectAnchorNavigate as Navigation } from "shared/pages/project/components/ProjectAnchorNavigate";


export interface ITeamTab {
    path: string;
    name: LangObject[];
    about: LangObject[];
    filter: ITeamFilterModel;
    isMain: boolean;
}

type TeamTabEditPropsT = {
    title?: any;
    titleVisible?: boolean;
    additionalContent?: IAddProjectCoverContent;
    managedTags: Tag[];
    teamTags: Tag[];
    team: ComputedTeam;
    isModer?: boolean;
    buttons?: ReactElement;
    color: string;
    isPreview?: boolean;
    mobileEditorAction?: string;
    onUpdate?: () => void;
    projectSource?: any;
}

const ButtonsWrapper = styled.div<{ isBlackTheme?: boolean }>`
  position: relative;
  ${({ isBlackTheme }) => {
    // console.log(isBlackTheme)
    return isBlackTheme ? css`
    .hollow-button, .filled-button {
      color: #fefefe;
    }
  ` : null}};
`;

export const TeamLgView: FC<TeamTabEditPropsT> = (props) => {
    const { i18n } = useTranslation();
    const dispatch = useDispatch();
    const theme = useTheme();
    const is743 = useBreakpoint(LayoutConst.screen.s - 1);
    const outer = document.getElementById('landing-nav-portal');
    useScrollByAnchorElement();
    const { anchorLinks } = useSelector(HseContextSelector);
    
    const { scrollToElement } = useInstantScroll({
        navbarHeight: 64,
        anchorMenuHeight: 50,
        extraOffset: -40,
        minDuration: 2000,
        maxDuration: 2000,
        scrollSpeed: 1.0
    });

    // ВРЕМЕННОЕ РЕШЕНИЕ: Обработчик hash для TeamLgView
    // TODO: Рефакторить систему загрузки контента для интеграции с React
    // Проблема: динамический контент загружается после монтирования компонентов
    // Решение: повторные попытки поиска элемента с прокруткой страницы для загрузки контента
    useEffect(() => {
        const handleHashOnLoad = () => {
            if (window.location.hash) {
                const hash = window.location.hash.replace('#', '');
                
                const findAndScrollToElement = (targetId: string, attempts = 0, maxAttempts = 30) => {
                    let element = document.querySelector(`[data-rbd-draggable-id="${targetId}"]`);
                    if (!element) {
                        element = document.getElementById(targetId);
                    }
                    if (!element) {
                        element = document.querySelector(`[data-post-id="${targetId}"]`);
                    }
                    if (!element) {
                        element = document.querySelector(`[data-anchor="${targetId}"]`);
                    }
                    
                    if (element) {
                        scrollToElement(targetId, false);
                        return;
                    }
                    
                    if (attempts < maxAttempts) {
                        if (attempts % 5 === 0) {
                            window.scrollTo({
                                top: document.body.scrollHeight,
                                behavior: 'smooth'
                            });
                        }
                        
                        setTimeout(() => {
                            findAndScrollToElement(targetId, attempts + 1, maxAttempts);
                        }, 200);
                    }
                };
                
                setTimeout(() => {
                    findAndScrollToElement(hash);
                }, 1000);
            }
        };
        
        handleHashOnLoad();
        
        window.addEventListener('load', handleHashOnLoad);
        
        window.addEventListener('hashchange', handleHashOnLoad);
        
        return () => {
            window.removeEventListener('load', handleHashOnLoad);
            window.removeEventListener('hashchange', handleHashOnLoad);
        };
    }, [scrollToElement]);

    const { team, color, additionalContent, managedTags, teamTags, buttons, title, titleVisible, onUpdate, projectSource  } = props;

    const [longreadReady, setLongreadReady] = useState<boolean | null>(null);
    const [lgLength, setLgLength] = useState(0);

    const onLongreadIsReady = (val: any) => {
        setLongreadReady(val || true)
    }

    const { longread } = team;

    const vtype = !!longread ? longread?.viewType : 't-shape';

    const newTheme = useMemo(() => {
      const { theme: newTheme } = createThemeByColor(color, theme);
      return newTheme
    }, [color, theme])
     //@ts-ignore
    const isTeamHasLongreadCover = !!team?.longreadType 
         
    const customAdditionalContent = useMemo(() => 
          //@ts-ignore
          isTeamHasLongreadCover ? projectSource?.additionalContent : team?.additionalContent,
          [isTeamHasLongreadCover, projectSource, team]
        );
        
    const getAdjustedColor = (defaultColor: string, contentColor: string | undefined): string | undefined => 
          defaultColor === "#FEFEFE" && contentColor === "#FEFEFE" ? '#000000' : contentColor;
        
    const titleColor = getAdjustedColor(color, customAdditionalContent?.title?.color);
    const subtitleColor = getAdjustedColor(color, customAdditionalContent?.subtitle?.color);
    const projectBg = useMemo(() => (team?.additionalInfo?.color || '#fff') , [team])
    

  useEffect(() => {
    const element = document.querySelector('.first_as_cover-container') as HTMLElement
    if (element) {
      const navbar = document.querySelector('#navbar') as HTMLElement;
      const footer = document.querySelector("#footer-portal > div") as HTMLElement;
      const navbarHeight = navbar?.offsetHeight;
      const footerHeight = footer?.offsetHeight;
      const elementHeight = element.offsetHeight;
      const windowHeight = window.innerHeight;
      const diff = elementHeight + navbarHeight - windowHeight;
      if (diff > 0) {
        setTimeout(() => {
          window.scrollTo({top: diff + footerHeight, behavior: 'smooth'});
        }, 0)
      }
    }
  }, [longreadReady])

    const navgationVisible = useMemo(() => {
        if (customAdditionalContent) {
            const content = customAdditionalContent as IAddProjectCoverContent
            return !!content?.anchors?.anchorVisible && content?.anchors?.anchorType === ANCHOR_TYPE.popup && anchorLinks?.length
        }
        return undefined
    }, [customAdditionalContent, anchorLinks])

    const navigation = useMemo(() => {
      if (outer && navgationVisible) {
        return (
            createPortal(
                <Navigation 
                  anchors={anchorLinks} 
                  bg={projectBg}
                  element={document.body}
                />
            , document.body)
        )
      }
    } , [anchorLinks, projectBg, navgationVisible, outer, longreadReady])

    const PresentationBlock = useMemo(() => {
      const isBlack = newTheme?.app?.backgroundColor === '#2A3034';

      return (
          <ThemeProvider theme={newTheme}>
            <PSpresentationBlock
          //@ts-ignore 
              project={team}
              anchors={anchorLinks}
              title={ 
                  titleVisible ? (
                      <Title isAgeytomesh={false} isProjectEdit={false}>
                          {/*@ts-ignore*/}
                          {title?.text}
                      </Title>
                  ) : undefined
              }
              titleColor={titleColor}
              subtitleColor={subtitleColor}
              tags={sortTags([...teamTags, ...managedTags]).map((v) => {
                  const target = (v.tagId === AGEYTOMESH_TAG_ID || v.isTeamTag) ? '_blank' : '';
                
                  if (v.tagId === AGEYTOMESH_TAG_ID) {
                    return (
                      <EmptyLink key={v.tagId} onClick={() => window.open(process.env.REACT_APP_URL_AGEYTOMESH, target)}>
                      {/*@ts-ignore*/}
                      <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag>
                        {bTag.title(v)}
                      </BTag>
                      </EmptyLink>
                    )
                  }
                  return (
                    <LimitedLink key={v.tagId} to={CreateLinkTo.tag(v.tagId)} target={target}>
                      {/*@ts-ignore*/}
                      <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} /*organization={isRequired(v, organizationEntity.tagIds, true)}*/ isProjectsTag>
                        {bTag.title(v)}
                      </BTag>
                    </LimitedLink>
                  )
                  })
                }
                bottom={<TeamTempButtons team={team} />}
                //@ts-ignore
              //bottom={<ProjectButtons dropdownVerticalPos={isEmptyProjectTags ? 'top' : "bottom"} orientation={'horizontal'} project={team} onShouldReload={undefined}/>}
                //@ts-ignore
              //   dialog={ team && <OrganizationApprovalDialog project={team}/>}
          />
            <ButtonsWrapper isBlackTheme={isBlack}>
              {!is743 && (
                <>
                  <div id={'landing-nav-portal'} style={{ position: 'relative' }} />
                  {buttons}
                </>
              )}
          </ButtonsWrapper>
          {is743 && buttons}
      </ThemeProvider>
      )
    }, [buttons, anchorLinks, team, projectBg, title, titleVisible, i18n.language, titleColor, subtitleColor, newTheme, projectSource])

    //@ts-ignore
    const coverContent: ICoverContent = useMemo(() => {
        return {
          firstAsCover: true,
          editorComponent:  PresentationBlock,
          setFirstCover: undefined,
          isPresentation: true,
          onLongreadIsReady: onLongreadIsReady,
        }
      }, [i18n.language, titleColor, subtitleColor, anchorLinks])

    const lgPortalRef = useMemo(() => (longreadReady && document.querySelector("#lg-presentation-portal")), [longreadReady])

    useEffect(() => {
        dispatch(setType(vtype));
    }, [dispatch, vtype])

    useEffect(() => onUpdate && onUpdate() , [i18n.language, anchorLinks])

    const handleSetLgLength = (val: number) => {
        setLgLength(val)
    } 

    return (   
      <ThemeProvider theme={newTheme}>
        <PageViewportLayout vtype={vtype} offsetTop={0}>
            {/*<ProjectEditPageGrid isTeamPage offsetBottom={40}>*/}
            <CustomBgWrapper backgroundColor={color}>
            <GlobalColoring color={color} /*brighter={color.brighter} darker={color.darker}*/ />
            {/* {navigation} */}
            <PSLongread 
            //@ts-ignore
                project={team}
                longReadLength={lgLength}
                additionalContent={additionalContent}
                setLongReadLength={handleSetLgLength}
                mobileEditorAction={props.mobileEditorAction}
                // toggleMobileEditor={onToggleMobileEditor}
                // onSetMobTextLength={onSetMobTextBlockLength}
                isTeamLG
                coverContent={{...coverContent}}
                //@ts-ignore
                customLGId={team?.longreadType && team?.replaceLongreadId}
                projectSource={projectSource}
            />
            </CustomBgWrapper>
        {/*</ProjectEditPageGrid>*/}
        </PageViewportLayout>
      </ThemeProvider>
    );
};
